/**
 * Created by anatoly on 26.06.2025
 */

const Merge2BackpackTutorial = function () {
    return new TutorialScenario("merge2_backpack_tutorial", {
        onStart: function () {
            cleverapps.focusManager.showControlsWhileFocused(["backpackButton", "unitInfoView"]);

            cleverapps.tutorial.on("onResize", () => {
                this.steps.forEach((step, index) => {
                    if (this.stepNo <= index) {
                        step.finish();
                    }
                });
            }, this);
        },

        listSteps: () => [
            Merge2BackpackTutorial.createInsertStep(),
            Merge2BackpackTutorial.createOpenBackpackStep(),
            Merge2BackpackTutorial.createSpawnUnitStep(),
            Merge2BackpackTutorial.createCloseBackpackStep()
        ],

        isAvailable: function () {
            if (!Merge2.current || cleverapps.forces.isShown(Forces.BACKPACK) || !Merge2.current.isGameMode()) {
                return false;
            }

            if (!cleverapps.user.checkAvailable(cleverapps.config.availables.BACKPACK_TUTORIAL)) {
                return false;
            }

            return !Merge2.current.counter.isActive() && Boolean(Merge2.current.backpack.findUnitToStore());
        }
    });
};

Merge2BackpackTutorial.createInsertStep = function (forceConfig) {
    const options = {
        onCheckConditions: function (options) {
            if (options.backpack) {
                return true;
            }

            if (!options.unit || options.mergeUnit) {
                return false;
            }

            return Unit.IsApplicable(this.unit, options.unit);
        },

        onStart: function () {
            this.unit = Merge2.current.backpack.findUnitToStore();

            const createForce = () => {
                const backpackButton = this.backpackButton = cleverapps.aims.getTarget("backpack");

                backpackButton.showUp();
                backpackButton.disable();

                const force = cleverapps.clone(forceConfig || Forces.BACKPACK, true);
                force.finger = {
                    swipe: [this.unit.onGetView(), backpackButton],
                    checkVisible: false
                };
                const forceOptions = Merge2TutorialHelper.getHighlightCellsOptions([this.unit]);
                forceOptions.highlights.push(backpackButton, cleverapps.Scenes.GetMovingNode());
                forceOptions.actives = [this.unit.onGetView(), cleverapps.Scenes.GetMovingNode(), backpackButton];
                Merge2TutorialHelper.scrollToExtraBarRow(Merge2.current.backpack.index, () => {
                    if (this.isFinished() || this.backpackButton !== backpackButton) {
                        return;
                    }
                    this.force = Merge2TutorialHelper.createForce(this.unit.onGetView(), force, forceOptions);
                });
            };
            createForce();

            Merge2.current.field.on("changeDragging", (dragUnit) => {
                const playing = Boolean(dragUnit);
                this.backpackButton.dragAnimationLocked = playing;
                this.backpackButton.playDragAnimation(playing);
            }, this);

            cleverapps.tutorial.on("onResize", () => {
                if (this.isFinished() || cleverapps.aims.getTarget("backpack") === this.backpackButton) {
                    return;
                }

                if (cleverapps.forces.isRunningForce()) {
                    cleverapps.forces.closeRunningForce();
                }
                delete this.force;
                Merge2BackpackTutorial.releaseBackpackButton(this.backpackButton);
                createForce();
            }, this);

            Merge2.current.backpack.on("onInsertUnit", this.finish.bind(this), this);
        },

        onFinish: function () {
            Merge2BackpackTutorial.releaseBackpackButton(this.backpackButton);
            this.force && this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};

Merge2BackpackTutorial.releaseBackpackButton = function (backpackButton) {
    backpackButton.enable();
    backpackButton.dragAnimationLocked = false;
    backpackButton.playDragAnimation(false);
};

Merge2BackpackTutorial.createOpenBackpackStep = function () {
    const options = {
        onStart: function () {
            const backpackButton = cleverapps.aims.getTarget("backpack");

            this.force = Merge2TutorialHelper.createForce(backpackButton, {
                text: "Merge2.BackpackTutorial2"
            });

            cleverapps.tutorial.on("window_shown", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};

Merge2BackpackTutorial.createSpawnUnitStep = function () {
    const options = {
        onStart: function () {
            const backpackWindow = cleverapps.focusManager.currentWindow();
            const backpackComp = backpackWindow && ComponentUtils.findComponentByName(backpackWindow, "BackpackWindowComponent");
            if (!backpackComp) {
                this.finish();
                return;
            }

            const index = Merge2.current.backpack.slots.findLastIndex((s) => s.code !== undefined && s.stage !== undefined);
            const lastUnit = backpackComp.getUnitByIndex(index);

            console.log(index, lastUnit);

            this.force = Merge2TutorialHelper.createForce(lastUnit, {
                text: "Merge2.BackpackTutorial3",
                gravitate: MinimalDialogue.GRAVITATE.BOTTOM
            });

            Merge2.current.backpack.on("onSpawnUnit", this.finish.bind(this), this);
            Merge2.current.backpack.on("noSpace", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force && this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};

Merge2BackpackTutorial.createCloseBackpackStep = function () {
    const options = {
        onStart: function () {
            const backpackWindow = cleverapps.focusManager.currentWindow();
            const backpackComp = backpackWindow && ComponentUtils.findComponentByName(backpackWindow, "BackpackWindowComponent");

            if (!backpackComp) {
                this.finish();
                return;
            }

            const closeButton = ComponentUtils.findChildByName(backpackWindow, "closeButton");

            this.force = Merge2TutorialHelper.createForce(closeButton, {
                text: "Merge2.BackpackTutorial5",
                gravitate: MinimalDialogue.GRAVITATE.BOTTOM
            });

            cleverapps.tutorial.on("window_closed", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force && this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};